/* eslint-disable flowtype/no-types-missing-file-annotation */
import {connect} from 'react-redux';
import React from 'react';

// TripBoardCoachMark currently needs to support the same props from State as the heart button
import {mapStateToProps, StateProps} from './TripBoardButton';
import {
    TripBoardCoachMark,
    TripBoardsApolloProvider
} from '@homeaway/react-trip-board-button';

export type Props = {
    scratchpadLink: React.ComponentType;
} & StateProps;

export const TripBoardLink = ({scratchpadLink}) => {
    return scratchpadLink;
};

export const TripBoardCoachMarkComponent = ({
    abacus,
    scratchpadLink
}: Props) => (
    <TripBoardsApolloProvider>
        {(tripBoardsApolloProvider) => (
            <TripBoardCoachMark
                {...tripBoardsApolloProvider}
                abacus={abacus}
                scratchpadLink={scratchpadLink}
            />
        )}
    </TripBoardsApolloProvider>
);

export default connect(mapStateToProps)(TripBoardCoachMarkComponent);
